import { POLARIS_NAME } from './../../../copilot.model';
import { Component, inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CopilotService } from '../../../../../services/copilot.service';
import { DashboardWidget, WIDGET_QUESTIONS_MAP } from '../../../types';
import { AssetVersionPipe } from '../../../../../pipes/asset-version.pipe';
import { PolarisIconComponent } from '../../polaris-icon/polaris-icon.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {DashboardService} from '../../../../../services/dashboard.service';

@Component({
  selector: 'app-ask-polaris-side-drawer',
  imports: [ReactiveFormsModule, AssetVersionPipe, PolarisIconComponent],
  templateUrl: './ask-polaris-side-drawer.component.html',
  styleUrl: './ask-polaris-side-drawer.component.scss'
})
export class AskPolarisSideDrawerComponent implements OnInit {
  private copilotService = inject(CopilotService);
  private dashboardService = inject(DashboardService);
  private data = inject(MAT_DIALOG_DATA);
  private widgetQuestionsMap = WIDGET_QUESTIONS_MAP;
  public widgetQuestions: string[] = [];
  public widget: DashboardWidget | undefined;
  public polarisName = POLARIS_NAME;
  public customQuestionFormControl = new FormControl<string | null>(null, [Validators.required]);
  public close: () => void = () => {};
  public selectedMetrics: string[] = [];

  ngOnInit(): void {
    const data = this.data.data;
    this.widget = data.widget as DashboardWidget;
    this.widgetQuestions = this.widgetQuestionsMap[this.widget] ?? [];
    this.selectedMetrics = data.selectedMetrics ?? [];
    this.close = data.close;
  }

  onQuestionClicked(question: string): void {
    const filters = this.dashboardService.brandsFilters();
    this.close();
    setTimeout(() => {
      this.copilotService.triggerMessage(question,{origin:'widget',
        widgetContext: {
          name:this.widget,
          metrics: this.selectedMetrics,
          myBrand:filters.myBrand.key,
          myCompetitors: filters.myCompetitors.map(comp => comp.key),
          countries: filters.countries,
          device: filters.device,
          dateRange: filters.dateRange
      }});
    }, 500);
  }

  onSend(): void {
    const value = this.customQuestionFormControl.value?.trim();
    if (!value) return;

    this.close();
    setTimeout(() => {
      this.copilotService.triggerMessage(value);
      this.customQuestionFormControl.setValue('');
    }, 500);
  }
}
